import "./about.css";
import linkedin from "../../img/linkedin.png";
import github from "../../img/github.png";
import cvicon from "../../img/cv.png";
import cv from "../../img/timCV.pdf";
import aboutIcon from "../../img/about.png";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        {/* <div className="a-card bg"></div> */}
        <div className="a-card">
            <img src={aboutIcon} alt="tim2" className="a-img" />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">
        Hello there, my name is Timotius Mogot, but you can simply call me Tim. I am currently working as a Data Engineer, specialising in building and optimising data pipelines, managing cloud-based platforms, and ensuring high-quality, trusted data for decision-making.
        </p>
        <p className="a-sub">
       

        My experience spans across Snowflake, AWS (S3, EC2, RDS, Redshift), dbt, Talend Studio, SQL, and Python, with a strong focus on data quality management, governance, and reconciliation. I have worked extensively with multiple databases including MySQL, PostgreSQL, SQL Server, and Redshift, delivering solutions that profile, cleanse, and validate critical datasets.


        </p>
        <p className="a-sub">
        Prior to data engineering, I completed a Software Engineering Immersive bootcamp at Coder Academy, where I gained full-stack development experience (HTML, CSS, JavaScript, Python, Ruby on Rails, React, Node.js, MongoDB). This technical breadth gives me versatility in solving data challenges that require both engineering and software problem-solving skills.
        </p>

        <p className="a-sub">I also bring a unique background in financial markets, having worked as a proprietary trader and market analyst in FX since 2008. This experience developed my analytical mindset and deepened my interest in the intersection of technology, data, and finance. 

        </p>
        
        <p className="a-sub">
          I am passionate about delivering reliable, accurate, and well-governed data systems, and I thrive on tackling complex data problems that impact real-world business outcomes. If you are seeking a motivated and adaptable Data Engineer with strong technical and analytical foundations, I’d love to connect with you.
        </p>
        
        
        
          <div>
              <a href="https://github.com/Sky12072"><img className="sosmed" src={github} alt="github icon" /></a>
              <a href="https://www.linkedin.com/in/timotius-mogot"><img className="sosmed" src={linkedin}
                      alt="linkedin icon" /></a>
              <a href={cv}><img className="sosmed" src={cvicon}
                      alt="instagram icon" /></a> 
          </div>
        
          
        
      </div>
    </div>
  );
};

export default About;